import { Navigate, useLocation } from 'react-router-dom';
import { useMemberProfileCompletion } from '../contexts/MemberProfileCompletionContext';
import { isMemberProfileCompletionExemptPath } from '../utils/memberProfileCompletion';
import FullPageLoading from './FullPageLoading';

/**
 * Redirige les membres (fiche People liée) vers `/profile/edit`
 * tant que leurs informations d'identification ne sont pas complètes.
 */
export default function MemberProfileGate({ children }) {
  const location = useLocation();
  const { personId, complete, loading } = useMemberProfileCompletion();

  if (!personId || isMemberProfileCompletionExemptPath(location.pathname)) {
    return children;
  }

  if (loading) {
    return <FullPageLoading />;
  }

  if (!complete) {
    const returnFallback =
      location.pathname === '/profile/edit' ? '/dashboard' : location.pathname;
    return (
      <Navigate
        to="/profile/edit"
        replace
        state={{
          requireProfileCompletion: true,
          returnFallback,
        }}
      />
    );
  }

  return children;
}
